import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import styles from './CreateNews.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import moment from 'moment';
import { useFetchCategories } from '../../../../Hooks/Categories';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchNewsById } from '../../../../Hooks/News';
import { isEmpty, values } from 'lodash';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import './Quill.css';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import { toast } from 'react-toastify';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';

import he from 'he';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import TextEditor from '../../../Molecules/Email/TextEditor';
import DateInput from '../../../Atoms/Inputs/DateInput';

const UpdateNews = () => {
  const fileInputRef = useRef(null);
  const params = useParams();
  const customizedToast = useToast();
  const navigate = useNavigate();
  const { id } = params;
  const [imageSrc, setImageSrc] = useState('');
  const { data: categories } = useFetchCategories();
  const {
    data: news,
    isLoading,
    refetch: refetchNews,
  } = useFetchNewsById({ id });
  const formikRef = useRef(null);

  useEffect(() => {
    try {
      const decodedText = he.decode(
        'عاية صاحب السمو الشيخ محمد بن راشد آل مكتوم، نائب رئيس الدولة رئيس مجلس الوزرا'
      );
      console.log(decodedText);
    } catch (error) {
      console.error('Error decoding text:', error);
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetchNews();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(news)) {
      const newsData = news.data;
      const url = sanitizeAndValidateUrl(`${newsData?.url}${newsData?.image}`);

      formikRef.current?.setValues(
        {
          nameAr: newsData.title_AR || '',
          category: newsData.categoryId || '',
          postedDate: newsData.newsDate
            ? new Date(newsData.newsDate)
            : new Date(),
          newsTextAr: he.decode(newsData.newsTextAr || ''),
          image: null,
          imageUrl: url || '',
        },
        false
      );

      setImageSrc(url || '');
    }
  }, [news]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('مطلوب تعبئته'),
    postedDate: Yup.date().required('مطلوب تعبئته'),
    category: Yup.string().required('مطلوب تعبئته'),
    image: Yup.mixed()
      .nullable()
      .test('image-required', 'الصورة مطلوبة', function (file) {
        const { imageUrl } = this.parent;
        const hasExisting = !!imageUrl;
        const hasNew = file instanceof File;
        return hasExisting || hasNew;
      }),

    newsTextAr: Yup.string().required('مطلوب تعبئته'),
  });

  const createNews = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/News/News`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث الخبر بنجاح' : 'تم إنشاء الخبر بنجاح'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('AcademicYearId', '');
    formData.append('TitleAr', values.nameAr);
    if (values.image instanceof File) {
      formData.append('Image', values.image);
    }
    formData.append('Date', moment(values.postedDate).format('YYYY-MM-DD'));
    const eventId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('NewsId', eventId);
    formData.append('NewsTextAr', values.newsTextAr);
    formData.append('CategoryId', values.category);
    createNews.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={!isEmpty(id) ? 'تحديث الخبر' : 'إنشاء الخبر'}
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: news?.data?.title_AR || '',
            category: news?.data?.categoryId || '',
            postedDate: news?.data?.newsDate
              ? new Date(news?.data?.newsDate)
              : '',
            newsTextAr: he.decode(news?.data?.newsTextAr || ''),
            image: null,
            imageUrl: '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched, resetForm }) => {
            console.log('values: ', errors);
            return (
              <Form>
                <div className={styles['step-container']}>
                  <div className={`${styles['rtl']}`}>
                    <TextInput
                      label='الاسم'
                      placeholder='أدخل الاسم'
                      icon={folderIcon}
                      style={{
                        width: '100%',
                        justifyContent: 'flex-start',
                      }}
                      containerStyle={{
                        padding: '0px',
                        justifyContent: 'flex-start',
                      }}
                      errors={errors.nameAr}
                      touched={touched.nameAr}
                      value={values.nameAr}
                      name='nameAr'
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                    />
                  </div>
                  <DateInput
                    label='التاريخ'
                    placeholder='حدد التاريخ'
                    showIcon
                    value={values.postedDate}
                    name='postedDate'
                    onChange={setFieldValue}
                    showTimeSelect={true}
                    dateFormat='yyyy-MM-dd'
                    timeFormat='HH:mm'
                    timeInputLabel='الوقت:'
                    errors={errors.postedDate}
                    touched={touched.postedDate}
                  />
                  <CustomSelect
                    label='اسم الفئة'
                    placeholder='أدخل الفئة'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ marginTop: '4px' }}
                    value={values.category}
                    onChange={(e) => {
                      setFieldValue('category', e.value);
                    }}
                    options={categories?.data.map((option) => ({
                      value: option.newsCategoryId,
                      text: option.category_AR,
                    }))}
                    touched={touched.category}
                    errors={errors.category}
                    type='category'
                    right
                  />{' '}
                </div>
                <div>
                  <div className={`${styles['quill-container']}`}>
                    <TextEditor
                      label='وصف الخبر'
                      value={values.newsTextAr}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                      modules={quillModules}
                      formats={quillFormats}
                      name='newsTextAr'
                      errors={errors.newsTextAr && touched.newsTextAr}
                      right
                    />
                  </div>
                </div>
                <label className={styles['quill-label']}>رفع الصورة</label>
                <div
                  className={styles['upload-container']}
                  onClick={() => {
                    if (fileInputRef.current) fileInputRef.current.value = '';
                    fileInputRef.current.click();
                  }}
                >
                  <input
                    type='file'
                    accept='image/*'
                    className='form-control form-body-input'
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={(event) => {
                      const file = event.currentTarget.files?.[0];

                      setFieldValue('image', file || null);
                      setFieldValue('imageUrl', '');

                      if (file) setImageSrc(URL.createObjectURL(file));
                    }}
                  />
                  {values.image || imageSrc ? (
                    <div className={styles['image-container']}>
                      <img
                        className={styles['uploaded-image']}
                        src={
                          values.image
                            ? URL.createObjectURL(values.image)
                            : imageSrc
                        }
                        alt='selected-image'
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = noImageFound;
                        }}
                      />
                      <button
                        className='delete-button-images'
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          setFieldValue('image', null);
                          setFieldValue('imageUrl', '');
                          setImageSrc('');

                          if (fileInputRef.current)
                            fileInputRef.current.value = '';
                        }}
                        title='حذف الصورة'
                        type='button'
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className={styles['upload-icon-container']}>
                      <img className={styles['upload-icon']} src={uploadIcon} />
                      <div className={styles['text-container']}>
                        <p className={styles['select-image']}>
                          اختر صورة للتحميل
                        </p>
                        <p className={styles['size']}>
                          {' '}
                          الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>
                        </p>
                      </div>
                      <p className='select-sizes'>
                        حجم الصورة: العرض: 406px الارتفاع: 292px
                      </p>
                    </div>
                  )}
                </div>{' '}
                {touched.image && errors.image && (
                  <div className={styles['error-message']}>
                    <p>{errors.image}</p>
                  </div>
                )}
                <button
                  type='submit'
                  className={styles['submit-button']}
                  style={{ display: 'none' }}
                >
                  إرسال
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateNews;
